var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UCAppHeaderItem',{attrs:{"icon":"fa-cart-shopping","data-external":"header-cart","title":"Cart"},on:{"on-click":_vm.toggleCartSidebar},scopedSlots:_vm._u([{key:"badge",fn:function(){return [(_vm.quantity)?_c('UCBadge',{attrs:{"color":"danger","count":_vm.quantity}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }